import { render } from "./HumanSvg.vue?vue&type=template&id=37124107"
import script from "./HumanSvg.vue?vue&type=script&lang=js"
export * from "./HumanSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__